export const isTokenExpired1 = (token) => {
  if (!token) return true;

  const payload = JSON.parse(atob(token.split(".")[1]));
  return payload.exp * 1000 < Date.now();
};

export const isTokenExpired = (token) => {
  // console.warn("Expiration Check!!!");

  if (!token) return true;

  try {
    const payload = JSON.parse(atob(token.split(".")[1]));

    return payload.exp * 1000 < Date.now();
  } catch (error) {
    console.error("Invalid token format", error);
    return true;
  }
};
